(ns graph-ui.web.interpret
  "CLJS port of ui.interpret/render-tree (PLAN-graph-ui-v0-001-02 Phase W4).

   The server-side interpreter (src/ui/interpret.clj) validates the description
   with malli then normalises it into a render tree. The web renderer skips
   validation (the server already validated) and does the same normalisation:
   {:widget :box ...} → {:type :box :props {...} :children [...]}.

   ADR-graph-ui-v0-004-01: Meta-UI is versioned, and the CLIENT never guesses its
   own copy of the rules — `rules` is the resolved rule-set the server sent
   in the :ui/attach reply's :meta-ui-rules field, for the specific
   :meta-ui-version the attached island targets. This replaces the earlier
   hardcoded widget-defaults duplicate, which was a real drift risk (kept
   in sync with dsl/contexts/ui.edn by hand) even before versioning existed,
   and untenable once several versions can be in play at once.

   Pure: no side effects, no bus, no renderer. The render tree is the seam the
   reagent widget components consume.")

;; @feature F-gi-v3-010-01-graph-ui-poc
;; @adr ADR-graph-ui-v0-003-01-ui-from-formal-description
;; @adr ADR-graph-ui-v0-004-01-meta-ui-versioning

(defn render-tree
  "Interpret an Actual-UI description into a renderer-agnostic RENDER TREE:
   {:type <widget> :props {…defaults+props…} :children [<render-tree> …]}.
   Same shape as ui.interpret/render-tree, minus malli validation.

   `rules` is the resolved Meta-UI rule-set for the attached island's own
   :meta-ui-version — {widget-kw {:defaults {...} ...}}, the exact shape
   ui.interpret/meta-ui returns server-side (the :ui/attach reply's
   :meta-ui-rules field)."
  [description rules]
  (letfn [(norm [node]
            (let [kind     (:widget node)
                  defaults (get-in rules [kind :defaults] {})
                  children (:children node)]
              (let [props (merge defaults (dissoc node :widget :children :bind :link-bind))]
                (cond-> {:type kind :props props}
                  (seq children) (assoc :children (mapv norm children))))))]
    (norm description)))
